// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderInfo_wrapper__M3Wht"};